module.exports = __webpack_public_path__ + "img/app-home-screen-dark.2a2fa4d2.png";